import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {WikipediaAnchorModel} from '../../../shared/semantic-enrichment/wikipedia-anchor.model';

@Component({
  selector: 'dialog-wikipedia-anchors',
  templateUrl: './dialog.wikipedia-anchors.component.html',
  styleUrls: ['./dialog.wikipedia-anchors.component.scss']
})
export class DialogWikipediaAnchorsComponent {

  @Input()
  private model: WikipediaAnchorModel[];

  constructor(public activeModal: NgbActiveModal) {
  }

  onClose() {
    this.activeModal.close(false);
  }

  dismiss(s: string) {
    this.activeModal.dismiss(s);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/dialog/dialog.wikipedia-anchors/dialog.wikipedia-anchors.component.ts